module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_gen_pref"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_auth_pref"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_bibliog"
    }
  }, [_vm._v("Select bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_intro"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_intro#sigil_toc_id_1"
    }
  }, [_vm._v("1. Mark among the Gospels")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_intro#sigil_toc_id_2"
    }
  }, [_vm._v("2. Characteristics of Mark’s Gospel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_intro#sigil_toc_id_3"
    }
  }, [_vm._v("3. The origin of Mark’s Gospel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_intro#sigil_toc_id_4"
    }
  }, [_vm._v("4. Theological emphases")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Mark_intro#sigil_toc_id_5"
    }
  }, [_vm._v("5. The structure of Mark’s Gospel")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Mark_analysis",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Analysis")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Mark_comment1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Commentary")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Mark_notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("More Titles from InterVarsity Press")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81c33348","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Mark_contents.vue
// module id = 60
// module chunks = 0